import request from './request';

const uri = 'auth/password/';

const auth = {
  post: (options) => request(uri, { method: 'POST', ...options }),
};

export default auth;
